import HowItWorksDialog from './HowItWorksDialog.module';
export default HowItWorksDialog;
